import { environment } from '@app/environments/environment';
import {
    EsResponseManyModel,
    EsResponseModel,
    LinkspaceDocumentModel,
} from '@app/models/elastic-search';
import { EsServiceBase } from '@app/services/abstracts/es-service.base';

export class EsLinkspacesService extends EsServiceBase {
    readonly #linkspaceEsIndexName = 'noc-linkspace';
    readonly #linkspaceEsIndexVersion = environment.LINKSPACES_ES_VERSION;

    private static _instance: EsLinkspacesService;

    protected get indexName(): string {
        return `${this.#linkspaceEsIndexName}-${this.#linkspaceEsIndexVersion}`;
    }

    public static get instance(): EsLinkspacesService {
        if (!this._instance) {
            this._instance = new EsLinkspacesService();
        }
        return this._instance;
    }

    /**
     * Load a linkspace document by ID, e.g.
     *   GET /noc-linkspace-3/_doc/city-{geoId}
     *   GET /noc-linkspace-3/_doc/cityCategory-{geoId}-{paramValue}
     *   GET /noc-linkspace-3/_doc/accommodation-{accommodationId}
     */
    public async loadById(docId: string): Promise<LinkspaceDocumentModel | null> {
        try {
            const response: EsResponseModel<LinkspaceDocumentModel> =
                await this.get<LinkspaceDocumentModel>(this.indexName, docId);
            return response?._source ?? null;
        } catch (error) {
            return null;
        }
    }

    public async loadAccommodationLinkspaces(
        accommodationId: string,
        cityId: string,
        categoryId: string,
    ): Promise<EsResponseManyModel<LinkspaceDocumentModel> | null> {
        try {
            const response: EsResponseManyModel<LinkspaceDocumentModel> =
                await this.getMany<LinkspaceDocumentModel>(this.indexName, {
                    query: {
                        terms: {
                            _id: [
                                `accommodation-${accommodationId}`,
                                `city-${cityId}`,
                                `cityCategory-${cityId}-${categoryId}`,
                            ],
                        },
                    },
                });
            return response ?? null;
        } catch (error) {
            return null;
        }
    }
}
